import { render, staticRenderFns } from "./photoUploader.vue?vue&type=template&id=a3f6842a&scoped=true"
import script from "./photoUploader.vue?vue&type=script&lang=js"
export * from "./photoUploader.vue?vue&type=script&lang=js"
import style0 from "./photoUploader.vue?vue&type=style&index=0&id=a3f6842a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f6842a",
  null
  
)

export default component.exports